import { Templates, utils, Components } from 'zero';
import { openTab } from '../../utils/common';

const { List } = Templates;
const { Toaster } = Components;
const searches = [{
  type: 'text',
  key: 'loanProductId',
  text: '贷款产品编号'
}, {
  type: 'text',
  key: 'loanProductName',
  text: '贷款产品名称'
}, {
  type: 'select',
  key: 'loanProductType',
  text: '贷款产品类型',
  value: '',
  options: [{
    value: '', text: '请选择'
  }, {
    value: '01', text: '个人小额信贷'
  }]
}, {
  type: 'select',
  key: 'channelBankId',
  text: '贷款银行渠道',
  options: [{
    value: '', text: '请选择'
  }, {
    value: 'jingu', text: '金谷农商行'
  }]
}, {
  type: 'timePickerRange',
  text: '贷款创建时间',
  items: [{
    key: 'startTime',
    type: 'date',
    dateFormat: 'YYYY-MM-DD HH:mm',
    style: {
      width: '160px'
    },
    after: '-'
  }, {
    type: 'date',
    dateFormat: 'YYYY-MM-DD HH:mm',
    key: 'endTime',
    style: {
      width: '160px'
    },
  }]
}];

const listFormat = [{
  key: 'loanProductId',
  title: '贷款产品编号'
}, {
  key: 'loanProductName',
  title: '贷款产品名称'
}, {
  key: 'loanProductType',
  title: '贷款产品类型',
  format: {
    '00': '个人小额信贷',
    '01': '企业小微信贷',
    '03': '个人大额贷款',
  }
}, {

  key: 'channelBankId',
  title: '银行渠道',
  format: {
    '01': 'jingu',
    jingu: '金谷农商行'
  }
}, {
  key: 'repaymentMethod',
  title: '还款方式',
  format: {
    '01': '等额本息'
  },
}, {
  key: 'loanProductTermType',
  title: '产品期限类型',
  format: {
    '01': '固定期限'
  },
}, {
  key: 'totalQuota',
  title: '产品总配额',
}, {
  key: 'createTime',
  title: '贷款创建时间',
  format: ['date', 'yyyy-MM-dd hh:mm:ss']
}, {
  key: 'productStatus',
  title: '贷款产品状态',
  options: [{ value: '01', text: '新建' },
  { value: '02', text: '修改' },
  { value: '03', text: '启用' },
  { value: '04', text: '禁用' },
  { value: '05', text: '废除' }],
  format: {
    '01': '待启用',
    '02': '待启用',
    '03': '已启用',
    '04': '已禁用',
    '05': '已废除',
  }
}];
const rule = [{ value: '01', rule: ['enable', 'disabled', 'detail', 'edit'] },
{ value: '03', rule: ['disabled', 'detail'] },
{ value: '04', rule: ['detail'] }];
const operationsRule = { relyKey: 'productStatus', crule: rule };

function refresh() {

}
const operations = [{
  text: '启用',
  func: (idx, item) => {
    const option = {
      method: 'POST',
      data: { loanProductId: item.loanProductId },
      headers: {
        token: localStorage.getItem('token'),
        userId: localStorage.getItem('userId')
      }
    };
    refresh();
    utils.fetch('/api/bosscredit/product/enable', option).then((res) => {
      Toaster.toaster({ type: 'success', content: res.message, time: 3000 });
      // window.location.href = `./creditProductDetail.html?id=${id}`;
    }, (error) => {
      Toaster.toaster({ type: 'error', content: (error && error.message) || '保存出错', time: 3000 });
    });
  },
  auth: 'enable',
}, {
  text: '禁用',
  func: (idx, item) => {
    const option = {
      method: 'POST',
      data: { loanProductId: item.loanProductId },
      headers: {
        token: localStorage.getItem('token'),
        userId: localStorage.getItem('userId')
      }
    };
    utils.fetch('/api/bosscredit/product/disable', option).then((res) => {
      Toaster.toaster({ type: 'success', content: res.message, time: 3000 });
      // window.location.href = `./creditProductDetail.html?id=${id}`;
    }, (error) => {
      Toaster.toaster({ type: 'error', content: (error && error.message) || '保存出错', time: 3000 });
    });
  },
  auth: 'disabled',
}, {
  text: '查看',
  func: (idx, item) => {
    const id = item.loanProductId;
    openTab('信贷产品详情', id, `credit/creditProductDetail.html?id=${id}`);
  },
  auth: 'detail',
}, {
  text: '编辑',
  func: (idx, item) => {
    const id = item.loanProductId;
    openTab('信贷产品详情', id, `credit/creditProductEdit.html?id=${id}`);
  },
  auth: 'edit',
}, {
  type: 'delete',
  func: (idx, item) => {
    console.log('delete', idx, item);
  },
  auth: 'delete',
}];

List({
  searches,
  operations,
  listFormat,
  operationsRule,
  url: '/api/bosscredit/product/query'
});



// WEBPACK FOOTER //
// ./example/src/page/creditProductSearch/index.js